import { registerProperties } from './useAnalytics'
import Router from 'next/router'

import mixpanel from 'mixpanel-browser'

import {
  hostnameShouldUseDevMixpanel,
  parseUrlForTracking,
} from './utils/helpers'

const hostname: string =
  // NOTE: Use typeof check here as it's evaluated server side before it exists in the browser context
  typeof window === 'undefined' ? '' : window?.location?.hostname ?? ''

const shouldUseDevMixpanel = hostnameShouldUseDevMixpanel(hostname)

const MIXPANEL_TOKEN =
  // TODO - Figure out what ENVs are set where
  process.env.NODE_ENV === 'production' && !shouldUseDevMixpanel
    ? process.env.NEXT_PUBLIC_MIXPANEL_TOKEN
    : process.env.NEXT_PUBLIC_MIXPANEL_DEV_TOKEN

const isChromatic = Boolean(process.env.NEXT_IS_CHROMATIC_BUILD)

mixpanel.init(MIXPANEL_TOKEN, {
  debug: shouldUseDevMixpanel,
  secure_cookie: true,
})
if (isChromatic) {
  mixpanel.disable()
}

// Track initial page view
if (typeof window !== 'undefined') {
  // Dont track empty path
  if (window.location?.pathname !== '/') {
    registerProperties()
    mixpanel.track(window.location?.pathname)
  }
}

Router.events.on('routeChangeComplete', (url) => {
  registerProperties(url)
  if (url !== '/') {
    const { path, properties } = parseUrlForTracking(url)
    mixpanel.track(path, properties)
  }
})

export { mixpanel }
